// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.instruction-text {
  font-size: 15px;
  color: #373334;
  font-weight: 700;
  margin-right: 5px;
}
.instruction-text-without-arrow {
  font-size: 15px;
  color: #373334;
  font-weight: 700;
  margin-bottom: 1px;
}
.instruction-text-with-warning {
  font-size: 15px;
  color: #373334;
  font-weight: 700;
  margin-bottom: 1px;
}
.arrow-icon {
  font-size: 20px;
}

.edit-btn-container {
  position: absolute;
  left: 58%;
  top: 2%;
  background-color: #f3f2f0;
  color: #373334;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px 4px 30px;
  border-radius: 30px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px;
  max-width: 310px;
  border: none;
  cursor: pointer;
  gap: 4px;
  outline: none !important;
}
.click-map-edit-btn-container {
  position: absolute;
  left: 54%;
  top: 2%;
  background-color: #f3f2f0;
  color: #373334;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px 4px 30px;
  border-radius: 30px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px;
  max-width: 340px;
  border: none;
  cursor: pointer;
  gap: 4px;
  outline: none !important;
}
.submit-edit-btn-container {
  position: absolute;
  left: 55.5%;
  top: 2%;
  background-color: #f3f2f0;
  color: #373334;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px 4px 30px;
  border-radius: 30px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px;
  max-width: 330px;
  border: none;
  cursor: pointer;
  gap: 4px;
  outline: none !important;
}
.close-boundary-edit-btn-container {
  position: absolute;
  left: 60.6%;
  top: 2%;
  background-color: #f3f2f0;
  color: #373334;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px 4px 30px;
  border-radius: 30px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px;
  width: 290px;
  border: none;
  cursor: pointer;
  gap: 4px;
  outline: none !important;
}

.edit-btn-icon {
  display: flex;
  align-items: center;
  margin-right: 10px; /* Adds spacing between icon and text */
}

.edit-btn-text {
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
}

.edit-button {
  display: flex;
  align-items: center;
  justify-content: center;
}

.edit-icon-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  /* border-radius: 50%;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px; */
  padding: 5px;
  cursor: pointer;
}


`, "",{"version":3,"sources":["webpack://./src/Components/DefaultCommunity/editMap/index.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,QAAQ;EACR,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,QAAQ;EACR,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,QAAQ;EACR,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB,EAAE,uCAAuC;AAC7D;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B;gDAC8C;EAC9C,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".instruction-text {\r\n  font-size: 15px;\r\n  color: #373334;\r\n  font-weight: 700;\r\n  margin-right: 5px;\r\n}\r\n.instruction-text-without-arrow {\r\n  font-size: 15px;\r\n  color: #373334;\r\n  font-weight: 700;\r\n  margin-bottom: 1px;\r\n}\r\n.instruction-text-with-warning {\r\n  font-size: 15px;\r\n  color: #373334;\r\n  font-weight: 700;\r\n  margin-bottom: 1px;\r\n}\r\n.arrow-icon {\r\n  font-size: 20px;\r\n}\r\n\r\n.edit-btn-container {\r\n  position: absolute;\r\n  left: 58%;\r\n  top: 2%;\r\n  background-color: #f3f2f0;\r\n  color: #373334;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 4px 10px 4px 30px;\r\n  border-radius: 30px;\r\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px;\r\n  max-width: 310px;\r\n  border: none;\r\n  cursor: pointer;\r\n  gap: 4px;\r\n  outline: none !important;\r\n}\r\n.click-map-edit-btn-container {\r\n  position: absolute;\r\n  left: 54%;\r\n  top: 2%;\r\n  background-color: #f3f2f0;\r\n  color: #373334;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 4px 10px 4px 30px;\r\n  border-radius: 30px;\r\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px;\r\n  max-width: 340px;\r\n  border: none;\r\n  cursor: pointer;\r\n  gap: 4px;\r\n  outline: none !important;\r\n}\r\n.submit-edit-btn-container {\r\n  position: absolute;\r\n  left: 55.5%;\r\n  top: 2%;\r\n  background-color: #f3f2f0;\r\n  color: #373334;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 4px 10px 4px 30px;\r\n  border-radius: 30px;\r\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px;\r\n  max-width: 330px;\r\n  border: none;\r\n  cursor: pointer;\r\n  gap: 4px;\r\n  outline: none !important;\r\n}\r\n.close-boundary-edit-btn-container {\r\n  position: absolute;\r\n  left: 60.6%;\r\n  top: 2%;\r\n  background-color: #f3f2f0;\r\n  color: #373334;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 4px 10px 4px 30px;\r\n  border-radius: 30px;\r\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px;\r\n  width: 290px;\r\n  border: none;\r\n  cursor: pointer;\r\n  gap: 4px;\r\n  outline: none !important;\r\n}\r\n\r\n.edit-btn-icon {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-right: 10px; /* Adds spacing between icon and text */\r\n}\r\n\r\n.edit-btn-text {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n}\r\n\r\n.edit-button {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.edit-icon-button {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: transparent;\r\n  /* border-radius: 50%;\r\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px; */\r\n  padding: 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
